module.exports = __webpack_public_path__ + "static/media/MyPartyActive.2e540fd9.svg";